import React from "react";
import Player from "../components/Player/Player";
import LiveRadioPlayer from "../components/Player/Radio/Player";
import Grid from "../components/Grid/Grid";
import PerformanceInfo from "../components/PerformanceInfo/PerformanceInfo";
import ShortFormPerformanceInfo from "components/PerformanceInfo/ShortFormPerformanceInfo";
import RadioPerformanceInfo, { RadioPerformanceLongInfo } from "components/PerformanceInfo/RadioPerformanceInfo";
import { getTileInfo, childrenTileMapper, isShortFormContent } from "../utils";


enum Component {
  Player,
  PerformanceInfo,
  Grid
};

const getComponentProps = (performance) => {
  const components = [];
  const mediaType = performance.mediaType && performance.mediaType.toLowerCase();
  const isAudioStream = mediaType === "audio_stream";

  const playerComponent = {
    type: 'player',
    info: getTileInfo(performance),
    performance,
    endScreenInfo: {
      header: isAudioStream ? 'Enjoy Met Opera On Demand' : 'You might also enjoy',
      tiles: (performance.relatedPerformances && performance.relatedPerformances.nodes.length > 0) ?
        childrenTileMapper(performance.relatedPerformances.nodes).slice(0, 3) : []
    }
  }

  const performanceInfoComponent = {
    type: 'performanceInfo',
    info: getTileInfo(performance)
  }

  const relatedPerformancesComponent = {
    type: 'grid',
    header: isAudioStream ? 'Enjoy Met Opera On Demand' : 'You might also enjoy',
    tiles: (performance.relatedPerformances && performance.relatedPerformances.nodes.length > 0) ?
    childrenTileMapper(performance.relatedPerformances.nodes).slice(0, 3) : [],
    showTrialCta: isAudioStream
  }

  if (isAudioStream) {
    components.push(
      performanceInfoComponent,
      playerComponent
    );
    if (performanceInfoComponent.info && performanceInfoComponent.info.fullSynopsis) {
      components.push({ ...performanceInfoComponent, type: "radioLongInfo" });
    }
  } else {
    components.push(playerComponent, performanceInfoComponent);
  }

  if (relatedPerformancesComponent.tiles.length > 0) {
    components.push(relatedPerformancesComponent);
  }

  return components;
}

const getComponents = (performance) => {
  const mediaType = performance.mediaType && performance.mediaType.toLowerCase();
  const isShortFormAsset = isShortFormContent(mediaType);

  return getComponentProps(performance).map((fullProps, index) => {
    const { type, ...props } = fullProps;
    let component;
    switch (type) {
      case 'player':
        component =  mediaType === 'audio_stream' ? <LiveRadioPlayer key={index} {...props} /> : <Player key={index} {...props} />;
        break;
      case 'performanceInfo':
        if (isShortFormAsset &&  mediaType !== 'audio_stream') {
          component =  <ShortFormPerformanceInfo key={index} {...props} />;
        } else {
          if(mediaType === 'audio_stream') {
            component =  <RadioPerformanceInfo key={index} {...props} />;
          } else {
            component =  <PerformanceInfo key={index} {...props} />;
          }
        }
        break;
      case 'radioLongInfo':
        component = <RadioPerformanceLongInfo key={index} {...props} />;
        break;
      case 'grid':
        component =  <Grid key={index} {...props} />;
        break;
    }
    return component;
  })
}

const getPageInfo = (performance) => {
  return {
    title: performance.name || "Met Opera On Demand",
    id: performance.id
  }
};

export default function parse(performance) {
  return {
    ...getPageInfo(performance),
    components: getComponents(performance)

  }
};

export { Component };
